import { apiSlice } from './apiSlice';

export interface Settings {
  id: number;
  companyName: string;
  companyCarrierId?: number | null;
  createdAt: string;
  updatedAt: string;
}

export interface UpdateSettingsRequest {
  companyName: string;
}

export const settingsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getSettings: builder.query<Settings, void>({
      query: () => '/settings',
      transformResponse: (response: { success: boolean; data: Settings }) => response.data,
      providesTags: ['Settings'],
    }),

    updateSettings: builder.mutation<Settings, UpdateSettingsRequest>({
      query: (data) => ({
        url: '/settings',
        method: 'PUT',
        body: data,
      }),
      transformResponse: (response: { success: boolean; data: Settings }) => response.data,
      invalidatesTags: ['Settings'],
    }),
  }),
});

export const { useGetSettingsQuery, useUpdateSettingsMutation } = settingsApi;
